import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'paywallOpened',
  'viewPlanPaywallClick',
  'requestEnterpriseDemoPaywall',
  'continueWithPlanPaywallClick',
] as const;

export const paywallEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
